export default function Renovar() {
    return (
        <div className="container mt-5">
            <h1>Renovar</h1>
        </div>
    )
}
